import { daysSince } from './time';

type JsonCookieRecord = Record<string, string>;

export function readJsonCookieRecord(cookieKey: string): JsonCookieRecord {
    if (typeof document === 'undefined') return {};
    const row = document.cookie.split('; ').find(r => r.startsWith(`${cookieKey}=`));
    if (!row) return {};
    try {
        return JSON.parse(decodeURIComponent(row.slice(cookieKey.length + 1)) || '{}');
    } catch {
        return {};
    }
}

export function writeJsonCookieRecord(cookieKey: string, data: JsonCookieRecord, maxAgeDays: number) {
    if (typeof document === 'undefined') return;
    // biome-ignore lint/suspicious/noDocumentCookie: cookie records are intentionally persisted in browser cookies.
    document.cookie = `${cookieKey}=${encodeURIComponent(JSON.stringify(data))}; path=/; max-age=${60 * 60 * 24 * maxAgeDays}`;
}

export function getJsonCookieRecordValue(cookieKey: string, recordKey: string): string | null {
    return readJsonCookieRecord(cookieKey)[recordKey] ?? null;
}

export function isTimestampWithinDays(timestamp: string | null | undefined, maxAgeDays: number): boolean {
    return !!timestamp && daysSince(timestamp) < maxAgeDays;
}

export function setJsonCookieRecordTimestamp(
    cookieKey: string,
    recordKey: string,
    maxAgeDays: number,
    timestamp = new Date().toISOString(),
): string {
    const cookie = Object.fromEntries(
        Object.entries(readJsonCookieRecord(cookieKey)).filter(([, value]) => isTimestampWithinDays(value, maxAgeDays)),
    );
    cookie[recordKey] = timestamp;
    writeJsonCookieRecord(cookieKey, cookie, maxAgeDays);
    return timestamp;
}
